import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Star, Car, TreePine, Accessibility } from 'lucide-react';

const amenities = [
  { icon: <Car size={16} />, text: 'Free Parking' },
  { icon: <Accessibility size={16} />, text: 'Accessible' },
  { icon: <TreePine size={16} />, text: 'Outdoor Seating' },
  { icon: <Car size={16} />, text: 'Delivery' },
];

const LocationSection = () => (
  <section className="section-padding" style={{ backgroundColor: '#ffffff' }}>
    <div className="container">
      <div className="text-center mb-5 reveal">
        <span className="section-subtitle">Find Us</span>
        <h2 style={{ fontFamily: 'Playfair Display, serif', fontSize: '2.5rem', fontWeight: 600 }}>
          Our Location
        </h2>
        <div className="gold-divider-center"></div>
      </div>

      <div className="row g-4">
        <div className="col-lg-5 reveal-left">
          <div className="p-5 h-100" style={{
            backgroundColor: '#faf8f5', borderRadius: '16px',
            border: '1px solid rgba(212, 175, 55, 0.1)'
          }}>
            <h3 className="mb-4" style={{ fontFamily: 'Playfair Display, serif', fontSize: '1.6rem', fontWeight: 600 }}>
              Visit Us
            </h3>

            {/* Google Rating badge */}
            <div className="d-flex align-items-center gap-2 mb-4 p-3" style={{
              backgroundColor: 'rgba(212,175,55,0.08)', borderRadius: '12px'
            }}>
              <Star size={20} fill="#D4AF37" color="#D4AF37" />
              <span style={{ fontWeight: 700, fontSize: '1.1rem' }}>4.9</span>
              <span style={{ color: '#999', fontSize: '0.85rem' }}>· 420 Google Reviews</span>
            </div>

            <div className="mb-4">
              <div className="d-flex align-items-start gap-3">
                <MapPin size={20} color="#D4AF37" style={{ marginTop: '4px', flexShrink: 0 }} />
                <div>
                  <h6 className="fw-bold mb-1" style={{ fontSize: '0.9rem' }}>Address</h6>
                  <p className="text-muted mb-0" style={{ fontSize: '0.9rem' }}>Seguku, Entebbe Road, Uganda</p>
                </div>
              </div>
            </div>

            <div className="mb-4">
              <div className="d-flex align-items-start gap-3">
                <Phone size={20} color="#D4AF37" style={{ marginTop: '4px', flexShrink: 0 }} />
                <div>
                  <h6 className="fw-bold mb-1" style={{ fontSize: '0.9rem' }}>Call</h6>
                  <p className="text-muted mb-0" style={{ fontSize: '0.9rem' }}>
                    <a href="tel:+256772206129" className="text-decoration-none text-muted">+256 772 206129</a><br />
                    <a href="tel:+256700682587" className="text-decoration-none text-muted">+256 700 682587</a>
                  </p>
                </div>
              </div>
            </div>

            <div className="mb-4">
              <div className="d-flex align-items-start gap-3">
                <Mail size={20} color="#D4AF37" style={{ marginTop: '4px', flexShrink: 0 }} />
                <div>
                  <h6 className="fw-bold mb-1" style={{ fontSize: '0.9rem' }}>Email</h6>
                  <p className="text-muted mb-0" style={{ fontSize: '0.9rem' }}>info@syrafoodpoint.com</p>
                </div>
              </div>
            </div>

            {/* Amenities */}
            <div className="d-flex flex-wrap gap-3 mb-4">
              {amenities.map((a, i) => (
                <span key={i} className="d-flex align-items-center gap-1" style={{
                  fontSize: '0.8rem', color: '#888', backgroundColor: '#f0f0f0',
                  padding: '6px 12px', borderRadius: '20px'
                }}>
                  {a.icon} {a.text}
                </span>
              ))}
            </div>

            <a href="https://maps.google.com/?q=Seguku+Entebbe+Road+Uganda" target="_blank" rel="noopener noreferrer"
              className="btn btn-gold w-100 mb-2" style={{ padding: '14px', fontSize: '0.85rem' }}>
              Get Directions
            </a>
            <Link to="/booking" className="btn btn-outline-gold w-100" style={{ padding: '14px', fontSize: '0.85rem' }}>
              Reserve Table
            </Link>
          </div>
        </div>

        <div className="col-lg-7 reveal-right">
          <div style={{ borderRadius: '16px', overflow: 'hidden', height: '100%', minHeight: '400px', boxShadow: '0 4px 30px rgba(0,0,0,0.08)' }}>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3989.7123456789!2d32.5892!3d0.0589!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMMKwMDMnMzIuMCJOIDMywrAzNSczMy4yIkU!5e0!3m2!1sen!2sug!4v1234567890"
              width="100%" height="100%" style={{ border: 0, minHeight: '400px' }}
              allowFullScreen="" loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Syra Food Point Location"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default LocationSection;
